<template>
  <el-upload action="" accept="image/*" :show-file-list="false" :before-upload="customUpload">
    <slot></slot>
  </el-upload>
</template>

<script>
import * as Api from '@/server/product'
import * as qiniu from 'qiniu-js'

export default {
  name: 'ImgUpload',
  data() {
    return {
      fileUrl: ''
    }
  },
  methods: {
    customUpload(file) {
      // 获取上传配置
      Api.getUpload({
        type: 'product',
        file_name: file.name
      }).then(res => {
        console.log(res)
        const { path, token, qiniuDomain } = res.data.data
        const putExtra = {
          fname: file.name
        }
        const config = {
          useCdnDomain: true
        }
        // 图片上传
        //  实例化七牛云的上传实例
        const observable = qiniu.upload(file, path, token, putExtra, config);

        //   设置实例的监听对象
        const observer = {
          //   接收上传进度信息
          next(res) {
            // 上传进度
          },
          // 接收上传错误信息
          // eslint-disable-next-line handle-callback-err
          error(err) {
          },

          // 接收上传完成后的信息
          complete: (res) => {
            this.showLoading = false;
            // 拼接路径字符串
            this.fileUrl = `${qiniuDomain}${res.key}`;
            // 上传成功  返回路径
            this.$emit('uploadSuccess', this.fileUrl);
          }
        };

        const subscription = observable.subscribe(observer); // 上传开始
      })
      return false
    },
  }
}
</script>

<style scoped>

</style>
